export enum ActivityEventType {
  AppWebhookUpdated = 'app.webhook-updated',
  AppSettingsUpdated = 'app.settings-updated',
  AppPaymentOptionsUpdated = 'app.payment-options-updated',
  CalloutEdited = 'callout.edited',
  CalloutCreated = 'callout.created',
  CalloutPublished = 'callout.published',
  CalloutUnpublished = 'callout.unpublished',
  CalloutDeleted = 'callout.deleted',
  CalloutAnswered = 'callout.answered',
  CalloutSegmentsAdded = 'callout.segments-added',
  CalloutSegmentsDeleted = 'callout.segments-deleted',
  CalloutSegmentsUpdated = 'callout.segments-updated',
  ContactCreated = 'contact.created',
  ContactDeleted = 'contact.removed',
  ContactProfileUpdated = 'contact.profile-updated',
  ContactUpdated = 'contact.updated',
  ContactRoleAdded = 'contact.role-added',
  ContactRoleRevoked = 'contact.role-revoked',
  ContactSegmentsAdded = 'contact.segments-added',
  ContactSegmentsDeleted = 'contact.segments-deleted',
  ContactSegmentsUpdated = 'contact.segments-updated',
  ContactContributionUpdated = 'contact.contribution-updated',
  ContactContributionStarted = 'contact.contribution-started',
  ContactContributionCancelled = 'contact.contribution-cancelled',
  ContactNewsletterGroupsUpdated = 'contact.newsletter-groups.updated',
  EmailTemplateAdded = 'email.template-added',
  EmailTemplateEdited = 'email.template-edited',
  EmailTemplateDeleted = 'email.template-deleted',
  EmailSent = 'email.sent',
  EmailSendFailed = 'email.send-failed',
  ContactPaymentInitiated = 'contact.payment.initiated',
  ContactPaymentFailed = 'contact.payment.failed',
  ContactPaymentSuccessful = 'contact.payment.successful',
  ContactPaymentCancelled = 'contact.payment.cancelled',
  ContactPaymentRefunded = 'contact.payment.refunded',
  NewsletterGroupsUpdated = 'newsletter.groups-updated',
}
